module.exports = __webpack_public_path__ + "img/frame-browser-foujita-ja.e9f6bc86.jpg";